export const APP_FILE_QUOTES_LIST_ROUTE = "/view-quotes";
export const APP_FILE_QUOTES_ROUTE = "/view-quotes/manage";
